import cldrLikelySubtags from '../data/supplemental/likelySubtags.json';
import cldrCurrencyData from '../data/supplemental/currencyData.json';
import cldrMetaZones from '../data/supplemental/metaZones.json';
import cldrTimeData from '../data/supplemental/timeData.json';
import cldrWeekData from '../data/supplemental/weekData.json';
import cldrPlurals from '../data/supplemental/plurals.json';
import cldrOrdinals from '../data/supplemental/ordinals.json';
import cldrNumberingSystems from '../data/supplemental/numberingSystems.json';
export default {
    cldrLikelySubtags,
    cldrCurrencyData,
    cldrMetaZones,
    cldrTimeData,
    cldrWeekData,
    cldrPlurals,
    cldrOrdinals,
    cldrNumberingSystems
};

//# sourceMappingURL=supplemental.js.map